import { IconRatingStar } from "@repo/assets/images";
const ReviewsSkeleton = () => {
  return <div className="mx-auto animate-pulse py-10 md:max-w-screen-xl" data-sentry-component="ReviewsSkeleton" data-sentry-source-file="ReviewsSkeleton.jsx">
      {/* Header Section */}
      <div className="mb-8 flex items-center justify-between">
        <div className="h-8 w-32 rounded bg-gray-300 md:w-48" />{" "}
        {/* Customer Reviews text */}
        <div className="h-6 w-28 rounded bg-gray-300 md:w-28" />{" "}
        {/* Login to review button */}
      </div>
      {/* Single Review Item */}
      <ul>
        <li className="border-b border-[#E3ECFA] pb-3">
          {/* Star Rating */}
          <div className="flex py-2">
            {[...Array(5)].map((_, index) => <IconRatingStar key={index} className="me-1 text-gray-300" />)}
          </div>
          {/* Username */}
          <div className="mb-3 h-5 w-32 rounded bg-gray-300" />
          {/* Review Text */}
          <div className="space-y-2">
            <div className="h-4 w-3/4 rounded bg-gray-300" />
            <div className="h-4 w-1/2 rounded bg-gray-300" />
          </div>
        </li>
      </ul>
    </div>;
};
export default ReviewsSkeleton;